// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"35f2c670","633":"20a46cbf","816":"20bb1a9c"}[chunkId] + ".chunk.js";
};